import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {Apollo} from "apollo-angular";
import { getOneCategoria } from "../../../graphql/graphql.queris";
import {NgIf} from "@angular/common";
import {NavBarComponent} from "../../nav-bar/nav-bar.component";
import {EspecialidadesServiciosComponent} from "../especialidades-servicios/especialidades-servicios.component";
import {TopBarComponent} from "../../../top-bar/top-bar.component";
import { environment } from '../../../../environments/environment';
import {SucursalesEspecialidadesComponent} from "./sucursales-especialidades/sucursales-especialidades.component";
import {PromocionesEspecialidadesComponent} from "./promociones-especialidades/promociones-especialidades.component";
import {FooterPersonaComponent} from "../../footer-persona/footer-persona.component";
import {
  ProcedimientosEspecialidadesComponent
} from "./procedimientos-especialidades/procedimientos-especialidades.component";
import { OriginalRouteService } from "../../../services/original-route.service";


@Component({
  selector: 'app-especialidad-details',
  standalone: true,
  imports: [
    NgIf,
    NavBarComponent,
    EspecialidadesServiciosComponent,
    TopBarComponent,
    SucursalesEspecialidadesComponent,
    PromocionesEspecialidadesComponent,
    FooterPersonaComponent,
    ProcedimientosEspecialidadesComponent
  ],
  templateUrl: './especialidad-details.component.html',
  styleUrl: './especialidad-details.component.css'
})
export class EspecialidadDetailsComponent implements OnInit{
  dataEspecialidad: any;
  originalNameEspecialidad: string | undefined;
  normalizedNameEspecialidad: string | undefined;
  serverImgenUrl = environment.imgUrl;





  constructor(
    private route: ActivatedRoute,
    private originalRouteService: OriginalRouteService,
    private apollo: Apollo
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.normalizedNameEspecialidad = this.route.snapshot.paramMap.get('namespecialidad') || '';
      /*this.route.queryParams.subscribe(params => {
        this.originalNameEspecialidad = params['original'] || this.normalizedNameEspecialidad;
      });*/

      this.originalNameEspecialidad = this.originalRouteService.getOriginalName() || this.normalizedNameEspecialidad;

      console.log(this.normalizedNameEspecialidad)
      console.log(this.originalNameEspecialidad)

      // const name = params.get('namespecialidad');

      if (this.normalizedNameEspecialidad !== null) {
       // this.originalNameEspecialidad;
        if (this.originalNameEspecialidad) {
          this.getEspecialidad(this.originalNameEspecialidad);
        } else {
          console.error('El valor de cod_serv_procedimiento no es válido.');
        }
      } else {
        console.error('El parámetro cod_serv_procedimiento no está presente en la URL.');
      }
    });
  }

  getEspecialidad(nameespecialidad: string): void {
    this.apollo.query({
      query: getOneCategoria,
      variables: { nameEspecialidad: nameespecialidad },
      fetchPolicy: 'no-cache',
    }).subscribe((result: any) => {
      this.dataEspecialidad = result?.data?.getAllDataWebPublic[0];
    }, (error) => {
      console.error('Error al obtener los datos del servicio procedimiento', error);
    });
  }
}
